import axios from "axios"
import SessionManager from "@/utils/session-manager"
const BASE_URI = process.env.API_NODE
const BASE_URI_GO = process.env.API_GO_URL + '/api/v1'

export default class ApiClient {
  static request(options={}) {
    return axios(this._prepareOptions(options))
  }

  static request_GO(options={}) {
    return axios(this._prepareOptions_GO(options))
  }

  static get(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "get"}))
  }
  
  static get_GO(url, options={}) {
    return this.request_GO(Object.assign(options,{url: url, method: "get"}))
  }

  static post(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "post"}))
  }

  static put(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "put"}))
  }

  static put_GO(url, options={}) {
    return this.request_GO(Object.assign(options,{url: url, method: "put"}))
  }

  static delete(url, options={}) {
    return this.request(Object.assign(options,{url: url, method: "delete"}))
  }

  static post_GO(url, options={}) {
    return this.request_GO(Object.assign(options,{url: url, method: "post"}))
  }

  static getUser() {

    // var usr = localStorage.getItem("usr");

    // if(usr != undefined && usr != ""){

    //   return  new Promise(
    //     // a função resolve() é chamada com a capacidade para resolver ou 
    //     // rejeitar a promise
    //     function(resolve, reject) {       
        
    //           resolve(JSON.parse(usr))
    //     });
    // }


    return this.request({url: "usuario", method: "GET"})
      .then((response) => 
      {
        //localStorage.setItem("usr",JSON.stringify(response.data))

       return response.data
      })
  }

  static putInvitedCodeUser(code) {
    return this.request({
      url: "usuario/code/friend",
      method: "POST",
      data: {
        Code: code
      }
    })
    .then((response) => {
      return response.data
    })
  }

  static postInviteFriendMail(data) {
    return this.request({
      url: "invited/members",
      method: "POST",
      data: { 
        convites: data
      }
    })
    .then((response) => {
      return response
    })
  }

  static getConvitesEnviados(userId) {
    return this.request({
      url: "convites/enviados/" + userId,
      method: "GET",
    })
    .then((response) => {
      return response.data
    })
  }

  static getFindInviteCode(code) {
    return this.request({
      url: "usuario/find/code/" + code,
      method: "GET",
    })
    .then((response) => {
      return response.data
    })
  }

  static getGoogleToken(code) {
    return this.request({
      url: "contact/google/token?code="+code,
      method: "GET"
    })
    .then((response) => {
      return response
    })
  }

 
  static updateUserInvestor() {

    return this.request({url: `user-investidor`, method: "PUT"})
      .then(response => {
        localStorage.setItem("usr","")
        return response;
      })
  }


  static getLoanRequest(id) {
    return this.request({url: `solicitacoes/${id}`, method: "GET"})
      .then(response => {
        let loanRequest = Object.assign({}, response.data)

        if(loanRequest.Empresa) {
          if(loanRequest.Empresa.DataFundacao) {
            loanRequest.Empresa.DataFundacao = new Date(loanRequest.Empresa.DataFundacao)
          }
          if(loanRequest.Empresa.DataConsultaEndividamento) {
            loanRequest.Empresa.DataConsultaEndividamento = new Date(loanRequest.Empresa.DataConsultaEndividamento)
          }
        }
        if(loanRequest.InicioCaptacao) {
          loanRequest.InicioCaptacao = new Date(loanRequest.InicioCaptacao)
        }
        if(loanRequest.FimCaptacao) {
          // loanRequest.FimCaptacaoText = loanRequest.FimCaptacao;
          loanRequest.FimCaptacao = new Date(loanRequest.FimCaptacao)
        }
        return loanRequest
      })
  }

  static getInvestor() {
    return this.request({url: "informacoes-investidor", method: "GET"})
      .then(response => {
        let investor = Object.assign({}, response.data)

        if(investor.DataNascimento) investor.DataNascimento = new Date(investor.DataNascimento)
        if(investor.RgDataEmissao) investor.RgDataEmissao = new Date(investor.RgDataEmissao)

        return investor
      })
  }

  static updateInvestorInformation(stepType, data) {
    let parsedData = Object.assign({StepType: stepType}, data)

    if(parsedData.DataNascimento) parsedData.DataNascimento = new Date(parsedData.DataNascimento.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))
    if(parsedData.RgDataEmissao) parsedData.RgDataEmissao = new Date(parsedData.RgDataEmissao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))

    return this.request({url: "informacoes-investidor", method: "PUT", data: parsedData})
      .then(response => {
        let investor = Object.assign({}, response.data)

        if(investor.DataNascimento) investor.DataNascimento = new Date(investor.DataNascimento)
        if(investor.RgDataEmissao) investor.RgDataEmissao = new Date(investor.RgDataEmissao)

        return investor
      })
  }

  static getReservaSolicitacao(id) {
    return this.request({
      url: `reserva/solicitacao/${id}`,
      method: 'GET',
    })
    .then(response => {
      return response.data;
    })
  }

  static getInvestmentReservation({loanRequestId}) {
    return this.request({
      url: `solicitacoes/${loanRequestId}/reserva-investimento`,
      method: 'GET',
      })
      .then(response => {
        return response.data
      })
      .catch(error => {
        if(error.response && error.response.status == 404) {
          return null
        } else {
          throw error
        }
      })
  }

  static createInvestmentReservation({loanRequestId: loanRequestId, investmentReservation, listaEspera = null}) {
    return this.request({
      url: `solicitacoes/${loanRequestId}/reserva-investimento`,
      method: 'POST',
      data: {
        Valor: Number.parseFloat(investmentReservation.Valor),
        ReInvestimento: Number.parseFloat(investmentReservation.ReInvestimento),
        listaEspera
      }})
      .then(response => {
        return response.data
      })
  }

  static updateInvestmentReservation(investmentReservation) {
    return this.request({
      url: `reserva-investimentos/${investmentReservation._id}`,
      method: 'PUT',
      data: {
        Valor: Number.parseFloat(investmentReservation.Valor),
        ReInvestimento: Number.parseFloat(investmentReservation.ReInvestimento)
      }})
      .then(response => {
        return response.data
      })
  }

  static cancelInvestmentReservation(investmentReservationID, motivo) {

    console.log("cancelInvestmentReservation",investmentReservationID, motivo)
    return this.request({
      url: `reserva-investimentos-CANCEL/${investmentReservationID}`,
      method: 'POST',
      data: {
        Motivo: motivo
      }})
      .then(response => {
        return response.data
      })
  }

  static inviteFriend(to, msg, name) {

    return this.request({
      url: 'invite/friend',
      method: 'POST',
      data: {
        to: to,
        msg: msg,
        name: name
      }
    })
    .then(response => {
      return response;
    });
  }

  static inviteCompany(to, msg, name, contact, phone) {

    return this.request({
      url: 'invite/company',
      method: 'POST',
      data: {
        to: to,
        msg: msg,
        name: name,
        contact: contact,
        phone: phone
      }
    })
    .then(response => {
      return response;
    });
  }

  static alterarSenha(data) {
    var senhaNova = data.senhaNova;
    var senhaAtual = data.senhaAtual;
    var id = data.id;

    return this.request({
      url: `profile/alterarSenha`,
      method: 'POST',
      data: {
        senha: senhaNova,
        senhaAtual: senhaAtual,
        id: id
      }})
      .then(response => {

        localStorage.setItem("usr","")
        return response
      })
  }

  static cadastrarSenha(data) {
    var senhaNova = data.senhaNova;
    var id = data.id;

    return this.request({
      url: `profile/cadastrarSenha`,
      method: 'POST',
      data: {
        senha: senhaNova,
        id: id
      }})
      .then(response => {

        localStorage.setItem("usr","")
        return response
      })
  }

  static criarnovasenha(data) {
    var password = data.password;
    var id = data.id;
    var token = data.token;

    return this.request({
      url: 'criarsenha',
      method: 'POST',
      data:{
        password: password,
        id:       id,
        token:    token
      }})
      .then(response => {

        localStorage.setItem("usr","")
        return response.data
      })
  }

  static validateToken() {
    return this.request({url: "validar-token", method: "GET"})
      .then(() => true)
      .catch(() => false)
  }

  static _prepareOptions(givenOptions) {
    if(!givenOptions.headers) { givenOptions.headers = {} }
    if(!givenOptions.headers["Accept"]) {
      givenOptions.headers["Accept"] = 'application/json'
    }
    if(!givenOptions.headers["Content-Type"]) {
      givenOptions.headers["Content-Type"] = 'application/json'
    }


    const accessToken = SessionManager.getAuthToken()

    if(accessToken) {
      givenOptions.headers = Object.assign(givenOptions.headers, {
        Authorization: `${accessToken}`
      })
    }


    givenOptions.data = JSON.stringify(givenOptions.data)
    givenOptions.url = `${BASE_URI}/${givenOptions.url}`
    return givenOptions
  }

  static _prepareOptions_GO(givenOptions) {
    if(!givenOptions.headers) { givenOptions.headers = {} }
    if(!givenOptions.headers["Accept"]) {
      givenOptions.headers["Accept"] = 'application/json'
    }
    if(!givenOptions.headers["Content-Type"]) {
      givenOptions.headers["Content-Type"] = 'application/json'
    }

    const accessToken = SessionManager.getAuthToken()

    if(accessToken) {
      givenOptions.headers = Object.assign(givenOptions.headers, {
        Authorization: `Bearer ${accessToken}`
      })
    }

    givenOptions.data = JSON.stringify(givenOptions.data)
    givenOptions.url = `${BASE_URI_GO}/${givenOptions.url}`
    return givenOptions
  }

  static getOpportunities() {
    return this.request({url: "investimentos/oportunidades", method: "GET"})
      .then(response => {

         var oportunidades = response.data

          //Ajustar ordem das das oportunidades (mais recente antes)
          // oportunidades = oportunidades.sort(function(a, b){return  (new Date(b.InicioCaptacao)) - (new Date(a.InicioCaptacao))});

           return oportunidades
      })
  }

  static getMeusEmprestimos() {
    return this.request({
        url: "emprestimos/meus",
        method: "GET"
      }).then(response => {
        return response.data
      })
  }

  static getInfosMyCCBs() {
    return this.request({
      url: "investimentos/meus/ccbs",
      method: "GET",
    }).then((response) => {
      return response;
    })
  }

  static GetMeuEmprestimo(id) {
    return this.request({url: "emprestimos/pre-aprovado/"+id, method: "GET"})
    .then(response => {
      return response.data
    })
  }

  static VerificaSenha(dado) {
    var password = dado.password;
    var id = dado.id;

    return this.request({
      url: 'emprestimos/verifica-senha',
      method: 'POST',
      data:{
        password: password,
        id:       id
      }})
      .then(response => {
        return response.data
      })
  }

  static atualizaStatus(id, status, motivo) {
    return this.request({
      url: 'empretimos/atualiza-status',
      method: 'POST',
      data:{
        id: id,
        status: status,
        motivo: motivo
      }
    }) 
    .then(response => {
      return response.data
    })
  }
  

  static AlteraStatusNotificacao(IDUsuario, IDProposta, status) {
    return this.request({
      url: 'empretimos/atualiza-status-notificacao',
      method: 'POST',
      data:{
        UserId:     IDUsuario,
        PropostaId: IDProposta,
        status:     status
      }
    }) 
    .then(response => {
      return response.data
    })
  }

  static getDocumentos(type, id) {
    return this.request({url: "documentos/" + type + "/" + id, method: "GET"})
      .then(response => {
        return response;
      });
  }

  static getDocumentosSolicitacao(id) {
    return this.request({
        url: "doc/solicitacao/"+ id,
        method: "GET",
      })
      .then((response) => {
        return response
      })
  }

  static postDocumentosSolicitacao(id,idSolicitacao, arquivos) {
    return this.request({
      url: "newdoc/solicitacao",
      method: "POST",
      data: {
        id: id,
        solicitacaoId: idSolicitacao,
        arquivos: arquivos
      }
    })
    .then((response) => {
      return response
    })
  }

  static createDocumentos(operationType, mongoFieldName, id, nomeArquivoSelecionado, arquivos) {

    return this.request({
      url: "documentos/create",
      method: "POST",
      data: {
        operationType: operationType,
        mongoFieldName: mongoFieldName,
        id: id,
        nomeArquivoSelecionado: nomeArquivoSelecionado,
        arquivos: arquivos
      }})
      .then(response => {
        return response;
      });
  }

  static postComprovanteFatura(id, mongoFieldName, arquivos) {
     return this.request({
       url: "FaturaTomador/comprovante",
       method: "POST",
       data: {
          id: id,
          mongoFieldName: mongoFieldName,
          arquivos: arquivos,
       }
     })
     .then(response => {
       return response;
     })
  }

  static getLoanImpact() {
    return this.request({
      url: "impacto",
      method: "GET",
    }).then((response) => {
      return response;
    });
  }

  static getCountLoanImpactInvestors(id) {
    return this.request({
      url: "impacto/qtdeInvestidor/" + id,
      method: "GET",
    }).then((response) => {
      return response;
    });
  }

  static getCountCcbInvestors(id) {
    return this.request({
      url: "ccb/qtdeInvestidor/" + id,
      method: "GET",
    }).then((response) => {
      return response;
    });
  }

  static getLoanImpactById(id) {
    return this.request({
      url: "impacto/" + id,
      method: "GET",
    }).then((response) => {
      return response;
    });
  }

  static getValorCaptadoLoanImpact(solicitacaoId) {
    return this.request({
      url: "impacto/valorCaptado/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response;
    });
  }

  static postApoiarLoanImpact(solicitacaoId, valor,valueReinv, anonimo, exibirQuantia) {
    return this.request({
      url: "impacto/apoiar",
      method: "POST",
      data: {
        solicitacaoId: solicitacaoId,
        valor: valor,
        reinvestimento: valueReinv,
        anonimo: anonimo,
        exibirQuantia: exibirQuantia
      }
    }).then(response => {
      return response;
    });
  }

  static postInvestirCcb(solicitacaoId, valor) {
    return this.request({
      url: "ccb/investir",
      method: "POST",
      data: {
        solicitacaoId: solicitacaoId,
        valor: valor
      }
    }).then(response => {
      return response;
    });
  }

  static getInvestidorLoanImpact(solicitacaoId) {
    return this.request({
      url: "impacto/investidor/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response;
    });
  }

  static getInvestidorCcb(solicitacaoId) {
    return this.request({
      url: "ccb/investidor/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response;
    });
  }

  static getCcbInvestidores(solicitacaoId) {

    return this.request({
      url: "ccb/assinatura/investidores/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response;
    });
  }
  

  static getFaturas(solicitacaoId) {
    return this.request({
      url: "FaturaTomador/solicitacao/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response.data;
    })
  }

  static getNotificationsUser(userId) {
    return this.request({
      url: "user/notifications/" +userId,
      method: "GET"
    }).then(response => {
      return response.data;
    })
  }

  static changeStatusNotification(id, status) {
    return this.request({
      url: "notifications/status/update",
      method: "POST",
      data : {
        id: id,
        status: status
      }
    }).then(reponse => {

      localStorage.setItem("usr","")
      return reponse;
    })
  }

  static getListaInvestidoresLoanImpact(solicitacaoId) {
    return this.request({
      url: "impacto/investidores/" + solicitacaoId,
      method: "GET"
    }).then(response => {
      return response;
    });
  }

  static getCcbById(id) {
    return this.request({
      url: "ccb/" + id,
      method: "GET",
    }).then((response) => {
      return response;
    })
  }

  static getInfosMyInvestments() {
    return this.request({
      url: "investimentos/meus",
      method: "GET",
    }).then((response) => {
      return response;
    })
  }

  static getInfosMyInvestmentsSolicitacoes(reservaInvestimentoId) {
    return this.request({
      url: "investimentos/meus/solicitacoes/"+reservaInvestimentoId,
      method: "GET",
    }).then((response) => {
      return response;
    })
  }

  static getMyAvalibleMoney() {
    return this.request({
      url: "investimentos/meus/money",
      method: "GET",
    }).then((response) => {
      return response;
    })
  }

  static updateProfile(data) {

    localStorage.setItem("usr","")

    return this.request({url: "profile/updateProfile", method: "PUT", data: data})
      .then(response => {
        return response;
      });
  }

  static getLoansByDocuments(document,tipo) {
    return this.request({
      url: "solicitacoes/documentos/" + document + "/" + tipo,
      method: 'GET',
    })
    .then(response => {
      return response;
    })
  }

  static createSolicitation(data){
    return this.request({
      url: "solicitacoes/created",
      method: "POST",
      data: data
    })
    .then(response => {
      return response;
    })
  }

  static userNotificationInvestor(id, options) {
    localStorage.setItem("usr","")
    return this.request({
      url: "user/notifications",
      method: "POST",
      data: {
        id: id,
        options: options,
      }
    })
    .then(response => {
      return response;
    })
  }

  static createNotificationsInvestor(id) {
    localStorage.setItem("usr","")
    return this.request({
      url: "user/create/notifications",
      method: "POST",
      data: {
        id: id
      }
    })
    .then(response => {
      return response
    })
  }

  static getAllWallet(id) {
    return this.request({
      url: "wallet/loans/"+id,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static getCarteiraExtrato(pagina) {
    return this.request_GO({
      url: `wallet/extrato/pagina/${pagina}`,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static getCarteiraItem(id) {
    return this.request_GO({
      url: `wallet/operacao/detalhe/${id}`,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static getCarteiraExtratoComFiltro(dIni, dFim, pagina) {
    return this.request_GO({
      url: `wallet/extrato/periodo/${dIni}/${dFim}/pagina/${pagina}`,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static getCarteiraOperacao(id) {
    return this.request_GO({
      url: `wallet/operacao/${id}`,
    })
    .then(response => {
      return response
    })
  }
  
  static getWalletSlice(id, pagina) {
    return this.request({
      url: `wallet/loans/${id}/${pagina}`,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static getWalletBank(code) {
    return this.request({
      url: "wallet/bank/"+code,
      method: "GET"
    })
    .then(response => {
      return response
    })
  }

  static postTransferencia(id, idInvestor, carteira, password) {
    return this.request({
      url: "wallet/new",
      method: "POST",
      data: {
        id: id,
        idInvestor: idInvestor,
        carteira: carteira,
        password: password
      }
    })
    .then(response => {
      return response
    })
  }

  static getComprovante(idComprovante) {
    return this.request({
      url: `wallet/comprovante/${idComprovante}`,
      method: "GET",
    })
    .then(response => {
      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/api-client.js